module.exports = __webpack_public_path__ + "static/media/venduta_cover.1195d993.jpg";